import store from '../../../vue/store'

export default {
  computed: {
    productData () {
      // eslint-disable-next-line
      return store.getters.getProductById(this.productId)
    },
    productCodeData () {
      // eslint-disable-next-line
      return store.getters.getSelectedProductCodeByCodeId(this.productCodeId)
    }
  }
}
